import { MessageFeedback } from '@api/tia/TiaConversationApi';
import { usePostFeedback } from '@api/tia/TiaConversationApiHooks';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import { useEffect, useState } from 'react';
import { useErrorMessage } from '../../../hooks/useErrorMessage';
import { AssistantMessage } from '../ChatMessage';
import { MessageFeedbackControl } from '../common/MessageFeedbackControl';
import { MessageHeader } from '../common/MessageHeader';
import { MessageInfoPanel } from '../common/MessageInfoPanel';
import { MessageText } from '../common/MessageText';
import { MessageView } from '../common/MessageView';

interface AssistantMessageViewProps {
  message: AssistantMessage;
  conversationId: string;
  isLastMessage: boolean;
  isFirstMessage: boolean;
}

export const AssistantMessageView = (props: AssistantMessageViewProps) => {
  const { message, conversationId, isLastMessage, isFirstMessage } = props;
  const [feedback, setFeedback] = useState<MessageFeedback | null>(null);
  const messageId = message.id;
  const { mutateAsync, isPending: isPostingFeedback } = usePostFeedback();
  const { getErrorMessage } = useErrorMessage();
  const { viewer } = useTeiaViewerContext();

  useEffect(() => {
    if (!feedback) {
      return;
    }
    mutateAsync(
      {
        conversationId,
        messageId,
        feedback,
      },
      {
        onError: (error) => {
          setFeedback(null);
          viewer.notificationCenter.pushNotification({
            type: 'Chatbot',
            status: 'error',
            message: getErrorMessage(error),
            title: 'Chatbot',
            displayed: true,
          });
        },
      },
    );
  }, [feedback]);

  return (
    <MessageView color="info.light">
      <MessageHeader title="🤖 Elliot">
        {!isFirstMessage && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
          >
            <MessageFeedbackControl
              value={feedback}
              onChange={setFeedback}
              isLoading={isPostingFeedback}
            />
            <MessageInfoPanel message={message} />
          </Box>
        )}
      </MessageHeader>
      <MessageText content={message.text} animated={isLastMessage} />
    </MessageView>
  );
};
